var Hls = window.Hls = require('@hola.org/hls.js').default;
var provider = module.exports = require('@hola.org/videojs5-hlsjs-source-handler');
provider.Hls = Hls;
provider.version = '1.0.27';
provider.hls_version = provider.Hls.version;
provider.provider_version = provider.VERSION;
